import React from 'react';
import classNames from 'classnames/bind';
import { Switch, Route } from 'react-router';
import { useLocation } from 'react-router-dom';
import styles from './assets/styles.scss';
import PageContainer from '../PageContainer/PageContainer';
import RelativeLink from '../../components/RelativeLink/RelativeLink';
import { routes, basePath } from './accountRoutes';
import { useMobileOnly } from '../../helpers/responsive';
import Protected from '../../components/Protected/Protected';

const cx = classNames.bind(styles);

export default function Account() {
  const { pathname } = useLocation();
  const isMobileOnly = useMobileOnly();

  return (
    <PageContainer
      showFooter
      showHeader
      dark
      pageTitle={routes.find(({ path }) => pathname === `${basePath}${path}`).label}
      contentClass={cx('account')}
    >
      <Protected requireLogin>
        {!isMobileOnly && (
          <div className={cx('navigation')}>
            {routes.map(({ label, path, icon }) => (
              <RelativeLink key={path} to={path} className={cx({ active: pathname === `${basePath}${path}` })}>
                {icon}
                {label}
              </RelativeLink>
            ))}
          </div>
        )}
        <Switch>
          {routes.map(({ path, component }) => (
            <Route key={path} path={`${basePath}${path}`} exact>
              {component}
            </Route>
          ))}
        </Switch>
      </Protected>
    </PageContainer>
  );
}
